import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {MobileCheck} from '../../services/mobile-check/mobile-check.service';
import {IBatch} from '../../models/batch.model';
import {ProjectService} from '../../services/project/project.service';
import {IBatchForecastMeasurement} from '../../models/batch-forecast-measurement.model';
import {TranslateModule, TranslateService} from '@ngx-translate/core';
import {MatIcon} from "@angular/material/icon";
import {MatIconButton} from "@angular/material/button";
import {MatFormField, MatLabel, MatOption, MatSelect, MatSuffix} from "@angular/material/select";
import {FormsModule} from "@angular/forms";
import {AccordionWrapperComponent} from "../../shared/components/accordion-wrapper/accordion-wrapper.component";
import {NgClass} from "@angular/common";
import {MatTooltip} from "@angular/material/tooltip";
import {MultiLineTooltipDirective} from "../../shared/directives/multi-line-tooltip/multi-line-tooltip.directive";

@Component({
  selector: 'colimo-forecast-measurement',
  templateUrl: './forecast-measurement.component.html',
  imports: [
    MatIcon,
    MatIconButton,
    TranslateModule,
    MatOption,
    MatFormField,
    FormsModule,
    MatSelect,
    AccordionWrapperComponent,
    NgClass,
    MatTooltip,
    MultiLineTooltipDirective,
    MatLabel,
    MatSuffix
  ],
  styleUrls: ['./forecast-measurement.component.scss']
})
export class ForecastMeasurementComponent implements OnInit {
  @Input() public batch: IBatch;
  // selected forecast measurement is an in and out parameter
  // can be updated be ForecastComponent from "outside"
  // or is updated for the ForecastComponent with the selectedForecastMeasurementChanged from here via selection
  @Input() public selectedForecastMeasurement: IBatchForecastMeasurement;
  @Output() public selectedForecastMeasurementChanged: EventEmitter<IBatchForecastMeasurement> = new EventEmitter<IBatchForecastMeasurement>();

  public isMobile: boolean;
  public isForecastMeasurementLoading = false;
  public forecastMeasurementResult: string;

  constructor(
      private projectService: ProjectService,
      private mobileCheck: MobileCheck,
      private translate: TranslateService
  ) {}

  public ngOnInit(): void {
    this.mobileCheck.getScreenSize().subscribe((deviceInfo) => {
      this.isMobile = deviceInfo.isMobile;
    });
  }

  public updateForecastMeasurementsByBatchId(): void {
    this.isForecastMeasurementLoading = true;
    // #508439 Update forecast measurements should only filter by productNr -- changed from updateForecastByBatchId to updateRetainMeasurementsByBatchId which only filters for productNr
    this.projectService.updateRetainMeasurementsByBatchId({ batchId: this.batch.batchId }).subscribe({
      next: (numberOfNewMeasurements: number) => {
        if (numberOfNewMeasurements > 0) {
          this.reloadForecastMeasurements();
          this.projectService.triggerRetainSampleReload();
        }
        this.forecastMeasurementResult = this.getUpdateForecaseMeasurementsResultText(numberOfNewMeasurements);
        setTimeout(() => {
          this.forecastMeasurementResult = undefined;
        }, 10000);
      },
      error: () => {
        this.isForecastMeasurementLoading = false;
      },
      complete: () => {
        this.isForecastMeasurementLoading = false;
      },
    });
  }

  public selectedMeasurementChanged(selectedMeasurement: IBatchForecastMeasurement) {
    this.selectedForecastMeasurement = selectedMeasurement;
    this.selectedForecastMeasurementChanged.emit(this.selectedForecastMeasurement);
  }

  private getUpdateForecaseMeasurementsResultText(numberOfNew: number): string {
    if (numberOfNew >= 0) {
      return ' - ' + numberOfNew + ' ' + this.translate.instant('dashboard.updatedForecastMeasurements');
    } else {
      return ' - ' + this.translate.instant('dashboard.errorUpdatingForecastMeasurements');
    }
  }

  private reloadForecastMeasurements(): void {
    this.isForecastMeasurementLoading = true;
    this.projectService.getForecastMeasurementsByBatchId({ batchId: this.batch.batchId }).subscribe({
      next: (forecastMeasurements: IBatchForecastMeasurement[]) => {
        if (forecastMeasurements) {
          // reset current selection after update
          this.selectedMeasurementChanged(null)
          this.batch.forecastMeasurements = forecastMeasurements;
        }
      },
      error: () => {
        this.isForecastMeasurementLoading = false;
      },
      complete: () => {
        this.isForecastMeasurementLoading = false;
      },
    });
  }
}
